

// Mappa: codice valuta (ISO 4217) -> nome base del file bandiera (codice paese ISO 3166-1 alpha-2)
const CURRENCY_FLAG_MAP = {
  AED: "ae", AFN: "af", ALL: "al", AMD: "am", ANG: "nl", AOA: "ao",
  ARS: "ar", AUD: "au", AWG: "aw", AZN: "az", BAM: "ba", BBD: "bb",
  BDT: "bd", BGN: "bg", BHD: "bh", BIF: "bi", BMD: "bm", BND: "bn",
  BOB: "bo", BRL: "br", BSD: "bs", BTN: "bt", BWP: "bw", BYN: "by",
  BZD: "bz", CAD: "ca", CDF: "cd", CHF: "ch", CLP: "cl", CNY: "cn",
  COP: "co", CRC: "cr", CUP: "cu", CVE: "cv", CZK: "cz", DJF: "dj",
  DKK: "dk", DOP: "do", DZD: "dz", EGP: "eg", ERN: "er", ETB: "et",
  EUR: "eu", FJD: "fj", FKP: "fk", GBP: "gb", GEL: "ge", GHS: "gh",
  GIP: "gi", GMD: "gm", GNF: "gn", GTQ: "gt", GYD: "gy", HKD: "hk",
  HNL: "hn", HRK: "hr", HTG: "ht", HUF: "hu", IDR: "id", ILS: "il",
  INR: "in", IQD: "iq", IRR: "ir", ISK: "is", JMD: "jm", JOD: "jo",
  JPY: "jp", KES: "ke", KGS: "kg", KHR: "kh", KMF: "km", KPW: "kp",
  KRW: "kr", KWD: "kw", KYD: "ky", KZT: "kz", LAK: "la", LBP: "lb",
  LKR: "lk", LRD: "lr", LSL: "ls", LYD: "ly", MAD: "ma", MDL: "md",
  MGA: "mg", MKD: "mk", MMK: "mm", MNT: "mn", MOP: "mo", MRU: "mr",
  MUR: "mu", MVR: "mv", MWK: "mw", MXN: "mx", MYR: "my", MZN: "mz",
  NAD: "na", NGN: "ng", NIO: "ni", NOK: "no", NPR: "np", NZD: "nz",
  OMR: "om", PAB: "pa", PEN: "pe", PGK: "pg", PHP: "ph", PKR: "pk",
  PLN: "pl", PYG: "py", QAR: "qa", RON: "ro", RSD: "rs", RUB: "ru",
  RWF: "rw", SAR: "sa", SBD: "sb", SCR: "sc", SDG: "sd", SEK: "se",
  SGD: "sg", SHP: "sh", SLE: "sl", SOS: "so", SRD: "sr", SSP: "ss",
  STN: "st", SVC: "sv", SYP: "sy", SZL: "sz", THB: "th", TJS: "tj",
  TMT: "tm", TND: "tn", TOP: "to", TRY: "tr", TTD: "tt", TWD: "tw",
  TZS: "tz", UAH: "ua", UGX: "ug", USD: "us", UYU: "uy", UZS: "uz",
  VES: "ve", VND: "vn", VUV: "vu", WST: "ws", YER: "ye", ZAR: "za",
  ZMW: "zm", ZWL: "zw",

  // Valute regionali: NON hanno una singola bandiera nazionale.
  // Scegli tu un paese rappresentativo o una bandiera generica.
  XOF: "default", // Franco CFA Africa Occidentale (8 paesi)
  XAF: "default", // Franco CFA Africa Centrale (6 paesi)
  XCD: "default", // Dollaro dei Caraibi Orientali
  XPF: "pf",      // Franco CFP (territori francesi del Pacifico)
};

const DEFAULT_FLAG = "default"; // placeholder se la valuta non è mappata
const EXT = "svg";              // estensione dei tuoi file bandiera

export default function getCurrencyFlag(currency) {
  if (!currency) return `${DEFAULT_FLAG}.${EXT}`;
  const code = currency.trim().toUpperCase();
  const flag = CURRENCY_FLAG_MAP[code] || DEFAULT_FLAG;
  return `${flag}.${EXT}`;
}